import { Panel, PanelBody, PanelGrid, PanelGridItem, PanelHeader, PanelLink, PanelTitle } from 'components';
import { Link } from 'react-router-dom';
import { CreditDetailHeaderData } from 'types';
import styles from './CreditDetailsHeader.module.scss';

type Props = {
    CreditDetailHeader: CreditDetailHeaderData
}

export default function CreditDetailHeader({ CreditDetailHeader }: Props) {

    return (
        <Panel className={styles.panel}>
            <PanelHeader className={styles.header}>
                <PanelLink>
                    <Link to={'/search'}>Back to Search</Link>
                </PanelLink>
                <div className={styles.heading}>
                    <PanelTitle>{CreditDetailHeader.creditNumber} | {CreditDetailHeader.vendorId}</PanelTitle>
                </div>
            </PanelHeader>
            <PanelBody className={styles.body}>
                <PanelGrid className={styles.grid}>
                    <div className={styles.gridItem}>
                        <PanelGridItem
                            label={"Type: "}
                            value={<span>{CreditDetailHeader.type}</span>}
                        />
                    </div>
                    <div className={styles.gridItem}>
                        <PanelGridItem
                            label={"Date: "}
                            value={<span>{CreditDetailHeader.invoiceDate}</span>}
                        />
                    </div>
                    <div className={styles.gridItem}>
                        <PanelGridItem
                            label={"Claimed For: "}
                            value={<span>Payment #{CreditDetailHeader.paymentIdRef ? CreditDetailHeader.paymentIdRef : " Not Available"}</span>}
                        />
                    </div>
                </PanelGrid>
            </PanelBody>
        </Panel>
    )
}